<template>
  <div class="textWithHighlightComponent">
    <span v-for="(block, name, index) in splitText" v-text="block" :key="index"
          :class="isHighlightTerm(block) ? 'highlight' : ''">
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef } from 'vue';

import { TextWithHighlight } from '@/data/datatypes/TextWithHighlight';

interface Props {
  text: string;
  highlightRegex?: RegExp;
  textWithHighlights?: TextWithHighlight[];
}
const props = defineProps<Props>();

const splitText: ComputedRef<string[]> = computed(() => {
  if (props.textWithHighlights) {
    const result: string[] = [];
    for (const textWithHighlight of props.textWithHighlights) {
      if (textWithHighlight.pre) {
        result.push(textWithHighlight.pre);
      }
      if (textWithHighlight.highlight) {
        result.push(textWithHighlight.highlight);
      }
      if (textWithHighlight.post) {
        result.push(textWithHighlight.post);
      }
    }
    return result;
  } else if (props.text && props.highlightRegex) {
    const result: string[] = [];
    let remainder = props.text;
    while (remainder.length) {
      const match = props.highlightRegex.exec(remainder);
      if (!match) {
        result.push(remainder);
        remainder = '';
      } else {
        result.push(remainder.substr(0, match.index));
        result.push(match[0]);
        remainder = remainder.substr(match.index + match[0].length);
      }
    }
    return result;
  } else {
    return [props.text];
  }
});

function isHighlightTerm(text: string | undefined): boolean {
  if (text) {
    if (props.textWithHighlights) {
      for (const textWithHighlight of props.textWithHighlights) {
        if (textWithHighlight.highlight === text) {
          return true;
        }
      }
    } else if (props.highlightRegex) {
      return !!props.highlightRegex?.test(text);
    }
  }
  return false;
}
</script>

<style scoped lang="scss">
.textWithHighlightComponent {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.highlight {
  background-color: $colour-background-mid;
}
</style>
